import { useEffect, useState } from "react";
import { Input, Space } from "antd";

import { getLabel } from "../../../../../hooks/use-labels";
import HexButton from "../../../../../ui-kit/HexButtons";

import "./style.css";
import Notification from "../../../../../components/Notification";

const CouponFieldView = ({ onApply, couponValue, error }) => {
  const [code, setCode] = useState(couponValue || "");
  const [fieldError, setFieldError] = useState(error || "");

  useEffect(() => {
    setFieldError(error)
  },[error])


  const onChangeCode = ({ target: { value } }) => {
    setCode(value.trim() ? value : "");
    fieldError && setFieldError("");
  };

  const applyCoupon = () => {
    onApply(code);
  };

  return (
    <div className="coupon-field">
      <Space.Compact
        className={`full-width add-coupon-field-view ${
          fieldError ? "error-field-coupon" : ""
        }`}
        size="large"
      >
        <Input
          value={code}
          placeholder={getLabel("couponCodeLabel")}
          onChange={onChangeCode}
          onPressEnter={applyCoupon}
        />
        <HexButton
          size="lg"
          type="primary"
          disable={!code}
          htmlType="submit"
          onClick={applyCoupon}
          label={getLabel("applyLabel")}
        />
      </Space.Compact>

      {fieldError && <Notification type="required" message={error} image={false} />}
    </div>
  );
};

export default CouponFieldView;
